import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { UserLogin, AppState } from 'ngx-sds-login';
import { MsalService } from '@azure/msal-angular';
import { Store } from '@ngrx/store';
import { Md5 } from 'ts-md5';
import { environment } from 'src/environments/environment';

@Component({
  selector: "app-menu-referente",
  templateUrl: "./menu-referente.component.html",
  styleUrls: ["./menu-referente.component.scss"],
})
export class MenuReferenteComponent implements OnInit {
  roles: any;
  username: any;

  user$: Observable<UserLogin>;
  gravatarUrl: string = '';  

  constructor(
    private router: Router ,
    private authService: MsalService,
    private store: Store<AppState>,) {
      this.user$ = this.store.select(state => state.user);
      this.user$.subscribe(user => {
        if (user && user.vcCorreo) {
          // console.log('user', user);
          this.gravatarUrl = this.getGravatarUrl(user.vcCorreo);
        }
      });
    }

  ngOnInit(): void {
  }

  salir() {
    localStorage.clear();
    this.router.navigate(["Acceso"]);
  }

  getGravatarUrl(email: string): string {
    const hash = Md5.hashStr(email);
    return `https://www.gravatar.com/avatar/${hash}?d=retro`;
  }

  logout() {
    localStorage.removeItem('user');
    this.authService.logoutRedirect({ postLogoutRedirectUri: environment.postLogoutUrl });
  }  

}
